<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.leads.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="tables.leads.allFields"
                                        :activeFields.sync="tables.leads.fields"
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.leads.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.leads.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.leads.columnFilterValue
                                    "
                                    :sorterValue.sync="tables.leads.sorterValue"
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.leads.rows"
                                    v-bind="tables.leads"
                                >
                                    <template #over-table>
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            <CDropdown
                                                color="primary"
                                                :toggler-text="$t('actions')"
                                                class="m-2"
                                            >
                                                <CDropdownItem
                                                    tag="div"
                                                    :disabled="
                                                        !hasLeadsSelected
                                                    "
                                                    @click="
                                                        openModal({
                                                            modalName:
                                                                'sendLeadsToCampaign',
                                                            data: {
                                                                leads: getLeadsSelected(),
                                                            },
                                                        })
                                                    "
                                                >
                                                    {{ $t("Send leads") }}
                                                </CDropdownItem>
                                                <CDropdownItem
                                                    tag="div"
                                                    :disabled="
                                                        !hasLeadsSelected
                                                    "
                                                    @click="
                                                        openModal({
                                                            modalName:
                                                                'sendLeadsToDeliveryCampaignWithTrollingDelivery',
                                                            data: {
                                                                leads: getLeadsSelected(),
                                                            },
                                                        })
                                                    "
                                                >
                                                    {{
                                                        $t("Throlling delivery")
                                                    }}
                                                </CDropdownItem>
                                            </CDropdown>
                                            <CButton
                                                class="m-2"
                                                color="primary"
                                                variant="outline"
                                                @click="
                                                    openModalThrollingDeliverySendingAllPages()
                                                "
                                            >
                                                Send Throlling Delivery
                                            </CButton>
                                        </div>
                                    </template>
                                    <template #_selected-header>
                                        <CInputCheckbox
                                            @update:checked="selectAllLeads"
                                        />
                                    </template>
                                    <template #_selected="{ index }">
                                        <td class="py-2">
                                            <CInputCheckbox
                                                :checked.sync="
                                                    tables.leads.items[index]
                                                        ._selected
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #LeadId="{ item }">
                                        <td class="py-2">
                                            <RouterLink
                                                :to="
                                                    '/app/campaigns/' +
                                                    uuid +
                                                    '/leads/' +
                                                    item.LeadId
                                                "
                                                >{{ item.LeadId }}</RouterLink
                                            >
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/capture-campaign/' +
                                                    uuid +
                                                    '/leads'
                                                "
                                                :baseURL="ApiSass"
                                                :adapterFilters="
                                                    adapterFiltersInExport
                                                "
                                                :table="tables.leads"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.leads.total_pages > 0">
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.leads.page"
                                    :pages="tables.leads.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>

        <SendLeadsToDeliveryCampaignModal
            v-bind="modals.sendLeadsToCampaign"
            :leads="modals.sendLeadsToCampaign.data.leads"
            :show.sync="modals.sendLeadsToCampaign.show"
            v-on:submit="resetLeadsSelected"
        />

        <CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal
            v-bind="modals.sendLeadsToDeliveryCampaignWithTrollingDelivery"
            :leads="modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.data.leads"
            :initialLeadIds="modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.data.prefilledIds"
            :show.sync="modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.show"
            v-on:submit="resetLeadsSelected"
        />
    </CCard>
</template>

<script>
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import SendLeadsToDeliveryCampaignModal from "./Components/SendLeadsToDeliveryCampaignModal";
import CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal from "~/components/CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal";
import ButtonBack from "£lement/ButtonBack";
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import modalMixin from "~/mixins/modal";
import TableSettings from "£lement/TableSettings";
import LeadsTable from "./config/tables/leads";
import { isReservedField } from "../../../utils/tables";

export default {
    name: "CampaingLeadsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        FilterDate,
        FilterFields,
        TableSettings,
        ButtonBack,
        ButtonExport,
        SendLeadsToDeliveryCampaignModal,
        CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                leads: LeadsTable,
            },
            modals: {
                sendLeadsToCampaign: {
                    show: false,
                    color: "primary",
                    title: "Send leads",
                    data: {
                        leads: [],
                    },
                },

                sendLeadsToDeliveryCampaignWithTrollingDelivery: {
                    show: false,
                    color: "primary",
                    title: "Throlling Delivery",
                    data: {
                        leads: [],
                        prefilledIds: "",
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),

        hasLeadsSelected() {
            return this.getLeadsSelected().length > 0;
        },

        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    watch: {
        "modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.show"(val) {
            if (!val) {
                this.modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.data.leads = [];
                this.modals.sendLeadsToDeliveryCampaignWithTrollingDelivery.data.prefilledIds = "";
            }
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.leads.rows = newValue;
            this.updatePagination(this.tables.leads.page);
        },
        updatePagination(newValue) {
            this.tables.leads.page = newValue;
            this.updateData();
        },
        resetLeadsSelected() {
            this.tables.leads.items.map((item) => (item._selected = false));
        },
        getLeadsSelected() {
            return this.tables.leads.items
                .filter((item) => item._selected)
                .map((item) => {
                    return { id: item.LeadId };
                });
        },
        adapterFiltersInExport(query) {
            query = {
                ...query,
                fields: this.tables.leads.fields
                    .filter((field) => !isReservedField(field))
                    .map((field) => {
                        return field.key;
                    }),
            };
            return query;
        },

        async openModalThrollingDeliverySendingAllPages() {
            const hasFilters = this.hasFiltersInTable({ tableName: "leads" });
            try {
                let prefilledIds = "";
                if (hasFilters) {
                    this.updatePageLoading(true);
                    const leads = await this.getLeadsInAllPages();
                    prefilledIds = leads.map((l) => l.id).join(",");
                }
                this.openModal({
                    modalName: "sendLeadsToDeliveryCampaignWithTrollingDelivery",
                    data: {
                        leads: [],
                        prefilledIds,
                    },
                });
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },

        async getLeadsInAllPages() {
            const tableName = "leads";
            // this.tables[tableName].loading = true;
            let table = {
                ...this.tables[tableName],
                rows: null,
                dateFieldFilter: "CreatedAtDate",
                orderField: "LeadId",
                matchResponse: "data.items",
                matchResponseCurrentPage: "data.currentPage",
                matchResponsePages: "data.pages",
            };
            const data = await this.loadTable({
                table,
                baseURL: process.env.VUE_APP_API_SASS,
                url: `/capture-campaign/${this.uuid}/leads`,
                adapterFilters: (query) => {
                    if ("origin" in query.where) {
                        if ("regexp" in query.where.origin) {
                            query.where.origin = {
                                in: query.where.origin.regexp,
                            };
                            delete query.where.origin.regexp;
                        }
                        query.where = {
                            ...query.where,
                            Origin: query.where.origin,
                        };
                        delete query.where.origin;
                    }
                    if ("id" in query.where) {
                        if ("regexp" in query.where.id) {
                            query.where.id = {
                                in: query.where.id.regexp,
                            };
                            delete query.where.id.regexp;
                        }
                        query.where = {
                            ...query.where,
                            LeadId: query.where.id,
                        };
                        delete query.where.id;
                    }
                    if ("email" in query.where) {
                        query.where = {
                            ...query.where,
                            email: query.where.email,
                        };
                        delete query.where.email;
                    }
                    query = {
                        ...query,
                        fields: ["LeadId"],
                    };

                    return query;
                },
            });

            // console.log({ leadIds: data.items.map((item) => item.LeadId) });

            return data.items.map((item) => {
                return { id: item.LeadId };
            });
        },
        selectAllLeads(checked) {
            this.tables.leads.items.forEach((item) => {
                item._selected = checked;
            });
        },

        async updateData() {
            await this.updateTable({
                tableName: "leads",
                url: `/capture-campaign/${this.uuid}/leads`,
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                },
                customFields: {
                    _selected: false,
                },
            });

            this.tables.leads.allFields = this.getTableAllFields("leads");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
    },
    mounted() {
        this.updateData({
            from: this.from,
            to: this.to,
        });
    },
};
</script>
